import * as Yup from 'yup';
import { useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
// material
import { Stack } from '@mui/material';
// component
import { api } from 'src/Api';
import { toast } from 'react-toastify';
import InputField from 'src/components/InputField';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import palette from 'src/theme/palette';

export default function ChangePasswordForm() {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');
  const token = queryParams.get('token');

  const RegisterSchema = Yup.object().shape({
    password: Yup.string().required('New Password is required'),
    confirmPassword: Yup.string()
      .required('Confirm New Password is required')
      .oneOf([Yup.ref('password')], 'The new password and confirm password do not match.')
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      setPassword();
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;
  const [loading, setloading] = useState(false);
  const [disabled, setdisabled] = useState(false);

  function setPassword() {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    var formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', values.password);
    formdata.append('password_confirmation', values.confirmPassword);
    formdata.append('token', token);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);

    fetch(api.updateforgotpassword, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json().then((error) => {
            toast.error(error.error);
            setloading(false);
          });
        }
      })
      .then((result) => {
        toast.success(result.message);
        localStorage.clear();
        setloading(false);
        setTimeout(() => {
          navigate('/login', { replace: true });
          setdisabled(true);
        }, 4000);
      })
      .catch((error) => {
        console.log(error);
        setloading(false);
      });
  }

  return (
    <Stack
      sx={{
        backgroundColor: '#fff',
        borderRadius: '15px',
        paddingX: 5,
        paddingY: 5,
        boxShadow: palette.primary.mainShadow,
        border: `1.5px solid ${process.env.REACT_APP_PRIMARY}`,
        marginBottom: 7
      }}
    >
      {/* <BackButton /> */}
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={0}>
            <InputField
              name="password"
              label="New Password"
              type="password"
              placeholder=""
              {...getFieldProps('password')}
              error={touched.password && errors.password}
              helperText={touched.password && errors.password}
              labelFontMedium
              fontFamily={'poppinsRegular'}
            />

            <InputField
              name="confirmPassword"
              label="Confirm New Password"
              type="password"
              placeholder=""
              {...getFieldProps('confirmPassword')}
              error={touched.confirmPassword && errors.confirmPassword}
              helperText={touched.confirmPassword && errors.confirmPassword}
              labelFontMedium
              fontFamily={'poppinsRegular'}
            />

            <LoadingButtonWrapper
              type="submit"
              loading={loading}
              title="Save"
              style={{ marginTop: 20 }}
              disabled={!formik.isValid || loading || disabled}
            />
          </Stack>
        </Form>
      </FormikProvider>
    </Stack>
  );
}
